/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SMPColorMapProvider
 * @hideconstructor
 * @classdesc
 */

define([
	'gemini/lib/@waca/dashboard-common/dist/core/APIFactory',
	'./SMPColorMapAPI'
], function (APIFactory, SMPColorMapAPI) {
	class SMPColorMapProvider {

		constructor() {}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [SMPColorMapAPI]);
			}
			return this.api;
		}

		/**
		 * getKeyForUserPalette gets key for user palette
		 * @param labelArray - an array of 1 or more labels that make up a tuple (label value) to be coloured  eg: ['Canada'] or ['Canada', '2005']
		 * @param dataItem - an object containing data item information
		 * @returns combined key concept + color mapping
		 */
		getKeyForUserPalette(labelArray, dataItem) {
			// once smarts is ready we'll use it to get the key with dataItem
			const label = labelArray && labelArray.join();
			const datasourceType = this._getDataSourceTypeForVIPRCatDataItem(dataItem);
			if( datasourceType && datasourceType === 'socialMediaProject') {
				return '@socialMedia'+label;
			}
			return undefined; //not supported
		}

		_getDataSourceTypeForVIPRCatDataItem(dataItem) {
			if(dataItem) {
				//TODO have a more generic way to get details from the dataItem
				//dataItem.source is a VIPRCatDataItem object,  implements ICatDataItem (See VIPRData)
				// dataItem.source.itemClassSets[0].dataItems[0].getMetadataColumn().getParent().sourceModelAPI.getType(); //TODO find a better way
				const source = dataItem.source;
				const itemClassSet = source && source.itemClassSets && source.itemClassSets[0];
				const _dataItem = itemClassSet && itemClassSet.dataItems && itemClassSet.dataItems[0];
				const metadataColumn = _dataItem && _dataItem.getMetadataColumn();
				const parent = metadataColumn && metadataColumn.getParent();
				const sourceModelAPI = parent && parent.sourceModelAPI;
				const dataSourceType = sourceModelAPI && sourceModelAPI.getType();
				return dataSourceType;
			}
			return undefined;
		}

		/**
		 * getUserColorMap gets user color map
		 * @returns user color map
		 */
		getUserColorMap() {
			return {
				'@socialMediaPositive': { r:0, g:170, b:94 },
				'@socialMediaPOSITIVE': { r:0, g:170, b:94 },
				'@socialMediaNegative': { r:230, g:35, b:37 },
				'@socialMediaNEGATIVE': { r:230, g:35, b:37 },
				'@socialMediaNeutral': { r:159, g:167, b:167 },
				'@socialMediaAmbivalent': { r:255, g:176, b:0 }
			};
		}

		hasApplicableColorMap(datasourceType /*,concepts*/) {
			return (datasourceType === 'socialMediaProject'); //TODO better check based on concepts...
		}
	}
	return SMPColorMapProvider;
});
